import React from 'react';

import Avatar from '../../../avatar/Avatar';
import BeautyScrollbar from '../../../beautyScrollbar/BeautyScrollbar';
import List from '../../../list/List';
import UserStatus from '../../../userStatus/UserStatus';

import GroupAccessLevelSelect from './GroupAccessLevelSelect';
import { DEFAULT_GROUP_ACCESS_LEVEL } from '../../../../utils/internalChatGroups';

import './group-access-level-select.scss';

/** Uma linha por usuário escolhido, com o seletor de nível. Quem ainda não foi mexido
 *  fica em "Enviar mensagens". Serve à criação do grupo e à adição de participantes.
 */
const ParticipantsAccessLevels = ({ users, participantLevels, setParticipantLevel }) => {
    return (
        <BeautyScrollbar style={{ maxHeight: '300px' }}>
            <List>
                <List.Group className="mb-50">
                    {users.map(user => (
                        <List.Item
                            key={`group_participant_${user.id}`}
                            className="group-participant-access-level"
                            active={false}
                            avatar={
                                <Avatar
                                    name={user.name}
                                    size="lg"
                                    color="primary"
                                    status={<UserStatus.Marker status={user} />}
                                />
                            }
                            title={user.name}
                            subtitle={user.email}
                            rightSideComponent={
                                <GroupAccessLevelSelect
                                    id={`group-participant-level-${user.id}`}
                                    role={user.role}
                                    value={participantLevels[user.id] || DEFAULT_GROUP_ACCESS_LEVEL}
                                    onChange={level => setParticipantLevel(user.id, level)}
                                />
                            }
                        />
                    ))}
                </List.Group>
            </List>
        </BeautyScrollbar>
    );
};

export default React.memo(ParticipantsAccessLevels);
